<template>
    <div class="main_center" style="margin: 0px 0px; padding-top: 8px;">
        <PmSearch ref="searchRef"
                  :form.sync="form"
                  :options.sync="searchConfigs"
                  label-width="72px"
                  @search="seachBtn">
            <template v-slot:afterSearchComSlot>
                <el-col  :span="24" style="padding-bottom: 16px">
                    <el-button size="small"  icon="el-icon-plus" type="primary"
                               @click="routerAdd('')">新增</el-button>
                    <el-button size="small" type="danger" plain icon="el-icon-delete"
                               @click="deleteSelectItem()">删除
                    </el-button>
                </el-col>
            </template>
        </PmSearch>
        <div class="content">
            <el-table
                    :data="tableData"
                    v-loading="dataListLoading"
                    ref="multipleTable"
                    :height="tableMaxHeight"
                    stripe
                    border
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        fixed
                        label="序号"
                        type="index"
                        :index="indexMethod"
                        width="50"
                        align="center"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column fixed type="selection" align="center"
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" align="left" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                                type="text"
                                size="small"
                                title="编辑"
                                @click="routerAdd(scope.row)">编辑</el-button>
                        <el-button
                                type="text"
                                size="small"
                                title="删除" @click="deleteById(scope.row)">删除</el-button>
                        <el-button
                                type="text"
                                size="small"
                                :title="scope.row.isShow?'隐藏':'显示'"
                                @click.stop="changeIsShow(scope.row)">{{scope.row.isShow?'隐藏':'显示'}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        label="文件名称"
                        prop="fileName"
                        align="left"
                        min-width="180"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        label="修改人"
                        prop="updateUser"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="修改时间"
                        prop="updateTime"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        label="创建人"
                        prop="createUser"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createTime"
                        header-align="left"
                        align="left"
                        width="180"
                        :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
            <pagination
                    class="limit"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="total"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange"
            ></pagination>
        </div>
        <el-dialog
                :title="diaTitle"
                width="600px"
                :visible.sync="visible">
            <el-form :model="dataForm"  :rules="dataRule" ref="dataForm"
                     label-width="150px">
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="文件名称：" prop="fileName">
                            <el-button @click="uploadFile">{{dataForm.fileName?'重新上传':'上传'}}</el-button>
                            <p>{{dataForm.fileName}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                        <el-form-item label="是否展示：">
                            <el-radio-group v-model="dataForm.isShow">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="visible = false">取消</el-button>
              <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
            </span>
        </el-dialog>
        <upload ref="uploadComRef" :accept-file-type="allowFileType" @uploadSuccess="uploadSuccess"></upload>
    </div>
</template>

<script>
    import Pagination from "@/components/Pagination.vue";
    import PmSearch from "@/components/PmSearch/index.vue";
    import {httpMixinsCommonPost, httpMixinsList} from "@/server/purchase";
    import upload from "@/components/affixMsg/upload";
    export default {
        name: "busWitnessTable",
        components: {
            Pagination,
            PmSearch,
            upload
        },
        data() {
            return {
                tableMaxHeight: document.documentElement.clientHeight - 275,
                dataListLoading: false,
                form: {
                    fileName:''
                },
                diaTitle:'编辑集中采购目录',
                allowFileType:'.pdf,.docx,.doc,.rar,.wps,.ofd',
                visible:false,
                dataForm:{
                    fileName:"",
                    filePath:"",
                    isShow:1,
                },
                dataRule:{
                    fileName: [
                        {required: true, message: '文件名称不能为空', trigger: 'change'}
                    ],
                },
                pageSize: 10, //每页条数
                pageIndex: 1, //当前页
                total: 0, //总条数
                tableData: [],
                multipleSelection: [],
                user: "", //角色类型
                formData: {},
                transactionCenterList: [],
                searchConfigs:[
                    {
                        type:'input',
                        key:'fileName',
                        label:'文件名称',
                        span:6
                    },
                ],
            };
        },
        props: {

        },
        filters: {
            ellipsis(text, num) {
                if (text.length > num) {
                    return text.substring(0, num) + "...";
                } else {
                    return text;
                }
            }
        },
        watch:{

        },
        activated() {
            this.getDataList();
        },
        created() {

        },
        mounted() {
            const that = this;
            let resizeTag = true;
            window.onresize = () => {
                if (resizeTag) {
                    //防抖动
                    that.ifmove();
                    resizeTag = false;
                    setTimeout(() => {
                        resizeTag = true;
                    }, 1000);
                }
            };
            that.ifmove();
        },
        computed: {},

        methods: {
            uploadSuccess(res){
                this.$set(this.dataForm,'fileName',res.fileName)
                this.$set(this.dataForm,'filePath',res.filepath)
            },
            uploadFile(){
                this.$refs.uploadComRef.selectFileClick();
            },
            changeIsShow(row){
                httpMixinsCommonPost('/purchase/catalog/updateShow', {
                    id: row.id,
                    isShow:row.isShow?0:1
                }).then(res => {
                    if (res.data.code == '1') {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        })
                        this.getDataList();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            },
            dataFormSubmit(){
                this.$refs.dataForm.validate((valid) => {
                    if (valid) {
                        this.formLoading = true;
                        httpMixinsCommonPost("/purchase/catalog/saveOrUpdate", this.dataForm)
                            .then(res => {
                                this.formLoading = false;
                                if (res.data.code == "1") {
                                    this.visible = false;
                                    this.getDataList();
                                    this.$message({
                                        type: "success",
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.data.msg
                                    });
                                }
                            });
                    }
                });

            },
            ifmove() {
                let tableMaxHeight = document.documentElement.clientHeight - 328;
                this.pageSize = parseInt(tableMaxHeight / 50) || 1;
                this.$nextTick(() => {
                    this.tableMaxHeight = tableMaxHeight;
                });
                // this.getDataList()
            },
            getDataList() {
                // 获取列表数据
                this.dataListLoading = true;
                httpMixinsList("/purchase/catalog/pagedList", {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    searchKey:this.form.fileName,
                    filter: {
                        purchaser:false,
                    }
                }).then((data) => {
                        this.dataListLoading = false;
                        if (data) {
                            this.tableData = data.data.rows || [];
                            this.total = data.data.total || 0;
                            this.$refs.multipleTable.doLayout();
                        }
                    });
            },

            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            paginationChange(obj) {
                this.pageIndex = obj.page || 1;
                this.pageSize = obj.limit || 5;
                this.getDataList();
            },
            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //搜索按钮
            seachBtn() {
                this.pageIndex = 1;
                this.getDataList();
            },
            reflash() {
                //刷新按钮
                this.pageIndex = 1;
                this.form = {};
                this.getDataList();
            },
            routerAdd(row){ //新增
                if(row){
                    this.dataForm = {...row};
                }else{
                    this.dataForm = {
                        fileName:"",
                        filePath:"",
                        isShow:1,
                    }
                }
                this.visible = true;
            },

            deleteById(item) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    httpMixinsCommonPost('/purchase/catalog/delete', {
                        id: item.id
                    }).then(res => {
                        if (res.data.code == '1') {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            })
                            this.getDataList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    })
                })
            },
            deleteSelectItem() {
                let ids = new Array();
                this.multipleSelection.forEach(key => {
                    ids.push(key.id)
                })

                if (ids != "" || ids.length > 0) {
                    this.$confirm(`确定要删除所选数据?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        httpMixinsCommonPost('/purchase/catalog/delete', {
                            idList: ids
                        }).then(res => {
                            if (res.data.code == '1') {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                })
                                this.getDataList();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.data.msg
                                })
                            }
                        })
                    })

                } else {
                    this.$message({
                        type: 'error',
                        message: "未选择删除项。"
                    })
                }

            },

        },

        destroyed() {
            window.onresize = null;
        }
    };
</script>
<style lang="less" scoped>


</style>
